// import "./ProductDetails.css";

// import { useState, useEffect, useMemo, useRef } from "react";
// import { useParams } from "react-router-dom";

// import {
//   FaTruck,
//   FaShieldAlt,
//   FaUndoAlt,
//   FaWhatsapp,
//   FaChevronLeft,
//   FaChevronRight,
//   FaSearchPlus,
//   FaTimes,
// } from "react-icons/fa";

// import ProductAccordion from "../../components/ProductAccordion/ProductAccordion";
// import { loadProductById } from "../../data/loadProductById";

// const ProductDetails = () => {
//   const { id } = useParams();

//   const [product, setProduct] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [selectedMedia, setSelectedMedia] = useState("");

//   // Zoom & Hover States
//   const [isHovering, setIsHovering] = useState(false);
//   const [zoomStyle, setZoomStyle] = useState({ display: "none" });

//   // Lightbox Modal & Thumbnail Preview States
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [hoveredThumb, setHoveredThumb] = useState(null);
//   const [thumbTooltipPos, setThumbTooltipPos] = useState({ top: 0, left: 0 });

//   const imageContainerRef = useRef(null);

//   /*==========================================
//           Helper to Identify Video Media
//   ==========================================*/
//   const isVideoFile = (url) => {
//     if (!url) return false;
//     const cleanUrl = String(url).split("?")[0].split("#")[0].toLowerCase();
//     return (
//       /\.(mp4|webm|ogg|mov)$/i.test(cleanUrl) ||
//       url === product?.video ||
//       url === product?.videoUrl
//     );
//   };

//   /*==========================================
//           Load Product
//   ==========================================*/
//   useEffect(() => {
//     async function fetchProduct() {
//       setLoading(true);
//       try {
//         const data = await loadProductById(id);
//         setProduct(data);
//       } catch (error) {
//         console.error("Unable to load product details:", error);
//         setProduct(null);
//       } finally {
//         setLoading(false);
//       }

//       window.scrollTo({
//         top: 0,
//         behavior: "smooth",
//       });
//     }

//     fetchProduct();
//   }, [id]);

//   /*==========================================
//           Gallery Setup
//   ==========================================*/
//   const media = useMemo(() => {
//     if (!product) return [];
//     const items = [...(product.images || [])];
//     if (product.video) {
//       items.push(product.video);
//     }
//     return items;
//   }, [product]);

//   useEffect(() => {
//     if (!product || !media.length) return;
//     setSelectedMedia(media[0]);
//   }, [product, media]);

//   const currentIndex = media.indexOf(selectedMedia);

//   const handleMediaSelect = (item) => {
//     setSelectedMedia(item);
//     setIsHovering(false);
//     setZoomStyle({ display: "none" });
//   };

//   const nextSlide = () => {
//     if (!media.length) return;
//     const next = (currentIndex + 1) % media.length;
//     handleMediaSelect(media[next]);
//   };

//   const prevSlide = () => {
//     if (!media.length) return;
//     const prev = (currentIndex - 1 + media.length) % media.length;
//     handleMediaSelect(media[prev]);
//   };

//   /*==========================================
//           Keyboard Handlers
//   ==========================================*/
//   useEffect(() => {
//     const handleKey = (e) => {
//       if (e.key === "ArrowRight") nextSlide();
//       if (e.key === "ArrowLeft") prevSlide();
//       if (e.key === "Escape") setIsModalOpen(false);
//     };

//     window.addEventListener("keydown", handleKey);
//     return () => window.removeEventListener("keydown", handleKey);
//   }, [selectedMedia, media]);

//   /*==========================================
//           Main Image Hover Zoom Logic
//   ==========================================*/
//   const handleMouseMove = (e) => {
//     if (isVideoFile(selectedMedia) || !imageContainerRef.current) return;

//     const { left, top, width, height } =
//       imageContainerRef.current.getBoundingClientRect();
//     const x = ((e.clientX - left) / width) * 100;
//     const y = ((e.clientY - top) / height) * 100;

//     setIsHovering(true);
//     setZoomStyle({
//       display: "block",
//       backgroundImage: `url(${selectedMedia})`,
//       backgroundPosition: `${x}% ${y}%`,
//       backgroundSize: "250%",
//     });
//   };

//   const handleMouseLeave = () => {
//     setIsHovering(false);
//     setZoomStyle({ display: "none" });
//   };

//   /*==========================================
//           Thumbnail Hover Preview
//   ==========================================*/
//   const handleThumbMouseEnter = (item, e) => {
//     if (isVideoFile(item)) return;
//     const rect = e.currentTarget.getBoundingClientRect();
//     setHoveredThumb(item);
//     setThumbTooltipPos({
//       top: rect.top - 10,
//       left: rect.right + 15,
//     });
//   };

//   const handleThumbMouseLeave = () => {
//     setHoveredThumb(null);
//   };

//   /*==========================================
//           WhatsApp Enquiry
//   ==========================================*/
//   const handleWhatsApp = () => {
//     const message = `Hello,\n\nI'm interested in this product.\n\nProduct:\n${product.name}\n\nPrice:\n${product.price}\n\nProduct Link:\n${window.location.href}\n\nPlease contact me.`;
//     const phoneNumber = "917720089312";
//     const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
//       message
//     )}`;
//     window.open(whatsappUrl, "_blank");
//   };

//   /*==========================================
//           Loading & Error States
//   ==========================================*/
//   if (loading) {
//     return (
//       <div style={{ padding: "180px 0", textAlign: "center" }}>
//         <h2>Loading Product...</h2>
//       </div>
//     );
//   }

//   if (!product) {
//     return (
//       <div className="container" style={{ padding: "180px 0", textAlign: "center" }}>
//         <h2>Product Not Found</h2>
//       </div>
//     );
//   }

//   return (
//     <>
//       <section className="product-details">
//         <div className="container">
//           {/* Breadcrumb */}
//           <div className="breadcrumb">
//             Home / Collection / {product.displayCategory}
//           </div>

//           <div className="product-wrapper">
//             {/* ================= Gallery ================= */}
//             <div className="product-gallery">
//               <div className="thumbnail-wrapper">
//                 <div className="thumbnail-images">
//                   {media.map((item, index) => {
//                     const isVideo = isVideoFile(item);

//                     return isVideo ? (
//                       <div
//                         key={index}
//                         className={
//                           selectedMedia === item
//                             ? "thumb video-thumb active"
//                             : "thumb video-thumb"
//                         }
//                         onClick={() => handleMediaSelect(item)}
//                       >
//                         ▶
//                       </div>
//                     ) : (
//                       <div
//                         key={index}
//                         style={{ position: "relative" }}
//                         onMouseEnter={(e) => handleThumbMouseEnter(item, e)}
//                         onMouseLeave={handleThumbMouseLeave}
//                       >
//                         <img
//                           src={item}
//                           alt={`Thumbnail ${index + 1}`}
//                           className={
//                             selectedMedia === item ? "thumb active" : "thumb"
//                           }
//                           onClick={() => handleMediaSelect(item)}
//                         />
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>

//               {/* Main Image with Hover Lens & Lightbox Trigger */}
//               <div
//                 className="main-image"
//                 ref={imageContainerRef}
//                 onMouseMove={handleMouseMove}
//                 onMouseLeave={handleMouseLeave}
//                 onClick={() => {
//                   if (!isVideoFile(selectedMedia)) setIsModalOpen(true);
//                 }}
//                 style={{
//                   cursor: !isVideoFile(selectedMedia) ? "zoom-in" : "default",
//                 }}
//               >
//                 <button
//                   className="slider-arrow left"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     prevSlide();
//                   }}
//                 >
//                   <FaChevronLeft />
//                 </button>

//                 {isVideoFile(selectedMedia) ? (
//                   <video
//                     key={selectedMedia}
//                     controls
//                     loop
//                     muted
//                     playsInline
//                     style={{ width: "100%", height: "100%", objectFit: "cover" }}
//                   >
//                     <source src={selectedMedia} type="video/mp4" />
//                     Your browser does not support HTML5 video.
//                   </video>
//                 ) : (
//                   <>
//                     <img src={selectedMedia} alt={product.name} />
//                     {isHovering && (
//                       <div className="zoom-lens-overlay" style={zoomStyle} />
//                     )}
//                     <div className="zoom-hint">
//                       <FaSearchPlus /> Click to expand
//                     </div>
//                   </>
//                 )}

//                 <button
//                   className="slider-arrow right"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     nextSlide();
//                   }}
//                 >
//                   <FaChevronRight />
//                 </button>

//                 <div className="image-counter">
//                   {currentIndex + 1} / {media.length}
//                 </div>
//               </div>
//             </div>

//             {/* ================= Product Info ================= */}
//             <div className="product-info">
//               <span className="product-category">{product.displayCategory}</span>
//               <h1 className="product-title">{product.name}</h1>
//               <h2 className="product-price">₹{Number(String(product.price ?? 0).replace(/[₹,\s]/g, "") || 0).toLocaleString("en-IN")}</h2>
//               <p className="tax-text">Inclusive of all taxes</p>

//               <div className="short-description">
//                 <p>{product.description}</p>
//               </div>

//               {/* Buttons */}
//               <div className="product-buttons">
//                 <button className="cart-btn">ADD TO CART</button>
//                 <button className="whatsapp-btn" onClick={handleWhatsApp}>
//                   <FaWhatsapp /> ENQUIRE ON WHATSAPP
//                 </button>
//               </div>

//               {/* Premium Highlights */}
//               <div className="product-highlights">
//                 <div className="highlight-item">
//                   <FaTruck className="highlight-icon" />
//                   <div>
//                     <h4>Free Shipping</h4>
//                     <p>Free delivery across India</p>
//                   </div>
//                 </div>

//                 <div className="highlight-item">
//                   <FaShieldAlt className="highlight-icon" />
//                   <div>
//                     <h4>100% Authentic</h4>
//                     <p>Certified Handloom Saree</p>
//                   </div>
//                 </div>

//                 <div className="highlight-item">
//                   <FaUndoAlt className="highlight-icon" />
//                   <div>
//                     <h4>Easy Exchange</h4>
//                     <p>7 Days Exchange Policy</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ================= Full-Screen Lightbox Modal ================= */}
//       {isModalOpen && (
//         <div className="lightbox-modal" onClick={() => setIsModalOpen(false)}>
//           <button className="modal-close-btn" onClick={() => setIsModalOpen(false)}>
//             <FaTimes />
//           </button>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <img src={selectedMedia} alt="Detailed view" className="modal-image" />
//           </div>
//         </div>
//       )}

//       {/* ================= Thumbnail Preview Tooltip ================= */}
//       {hoveredThumb && (
//         <div
//           className="thumb-hover-preview"
//           style={{
//             top: `${thumbTooltipPos.top}px`,
//             left: `${thumbTooltipPos.left}px`,
//           }}
//         >
//           <img src={hoveredThumb} alt="Preview" />
//         </div>
//       )}

//       {/* Product Details Accordion */}
//       <ProductAccordion product={product} />
//     </>
//   );
// };

// export default ProductDetails;

import "./ProductDetails.css";

import { useState, useEffect, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";

import {
  FaTruck,
  FaShieldAlt,
  FaUndoAlt,
  FaWhatsapp,
  FaChevronLeft,
  FaChevronRight,
  FaSearchPlus,
  FaTimes,
} from "react-icons/fa";

import ProductAccordion from "../../components/ProductAccordion/ProductAccordion";
import { loadProductById } from "../../data/loadProductById";

const ProductDetails = () => {
  const { id } = useParams();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedMedia, setSelectedMedia] = useState("");
  const [failedImages, setFailedImages] = useState([]);
  const [loadError, setLoadError] = useState("");

  const [isHovering, setIsHovering] = useState(false);
  const [zoomStyle, setZoomStyle] = useState({ display: "none" });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hoveredThumb, setHoveredThumb] = useState(null);
  const [thumbTooltipPos, setThumbTooltipPos] = useState({
    top: 0,
    left: 0,
  });

  const imageContainerRef = useRef(null);

  // Identify video files using their extension or product video URL.
  const isVideoFile = (url) => {
    if (!url) return false;

    const cleanUrl = String(url).split("?")[0].split("#")[0].toLowerCase();

    return (
      /\.(mp4|webm|ogg|mov|m4v)$/i.test(cleanUrl) ||
      url === product?.video ||
      url === product?.videoUrl
    );
  };

  // Load product from the API.
  useEffect(() => {
    let cancelled = false;

    const fetchProduct = async () => {
      setLoading(true);
      setProduct(null);
      setSelectedMedia("");
      setFailedImages([]);
      setLoadError("");
      setIsModalOpen(false);
      setHoveredThumb(null);

      try {
        const data = await loadProductById(id);

        if (cancelled) return;

        if (!data) {
          setProduct(null);
          return;
        }

        // Log the actual URLs to help diagnose image problems.
        console.log("Loaded product:", data.name);
        console.log("Product image list:", data.images);
        console.log("Primary image:", data.image);
        console.log("Product video:", data.video);

        setProduct(data);
      } catch (error) {
        if (cancelled) return;

        console.error("Unable to load product details:", error);
        setLoadError(error.message || "Unable to load this product.");
        setProduct(null);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchProduct();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    return () => {
      cancelled = true;
    };
  }, [id]);

  // Build the complete gallery from all images and the optional video.
  const media = useMemo(() => {
    if (!product) return [];

    const images = Array.isArray(product.images) ? product.images : [];

    const allImages = [product.image, ...images].filter(
      (item) => typeof item === "string" && item.trim(),
    );

    // Remove duplicate URLs while preserving the order.
    const uniqueImages = [...new Set(allImages)];

    const video = product.video || product.videoUrl;

    return video ? [...uniqueImages, video] : uniqueImages;
  }, [product]);

  // Select the first available media item when the gallery changes.
  useEffect(() => {
    setSelectedMedia(media[0] || "");
    setFailedImages([]);
  }, [media]);

  const currentIndex = media.indexOf(selectedMedia);

  const handleMediaError = (url) => {
    console.error("Failed to load media:", url);

    setFailedImages((previous) =>
      previous.includes(url) ? previous : [...previous, url],
    );
  };

  const handleMediaSelect = (item) => {
    setSelectedMedia(item);
    setIsHovering(false);
    setZoomStyle({ display: "none" });
    setIsModalOpen(false);
  };

  const nextSlide = () => {
    if (!media.length) return;

    const next = (currentIndex + 1) % media.length;
    handleMediaSelect(media[next]);
  };

  const prevSlide = () => {
    if (!media.length) return;

    const previous = (currentIndex - 1 + media.length) % media.length;

    handleMediaSelect(media[previous]);
  };

  // Keyboard navigation.
  useEffect(() => {
    const handleKey = (event) => {
      if (event.key === "Escape") {
        setIsModalOpen(false);
        return;
      }

      if (isModalOpen) return;

      if (event.key === "ArrowRight") nextSlide();
      if (event.key === "ArrowLeft") prevSlide();
    };

    window.addEventListener("keydown", handleKey);

    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  }, [selectedMedia, media, isModalOpen]);

  // Image hover zoom.
  const handleMouseMove = (event) => {
    if (
      !selectedMedia ||
      isVideoFile(selectedMedia) ||
      failedImages.includes(selectedMedia) ||
      !imageContainerRef.current
    ) {
      return;
    }

    const { left, top, width, height } =
      imageContainerRef.current.getBoundingClientRect();

    if (!width || !height) return;

    const x = ((event.clientX - left) / width) * 100;
    const y = ((event.clientY - top) / height) * 100;

    setIsHovering(true);

    setZoomStyle({
      display: "block",
      backgroundImage: `url("${selectedMedia}")`,
      backgroundPosition: `${x}% ${y}%`,
      backgroundSize: "250%",
    });
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
    setZoomStyle({ display: "none" });
  };

  // Thumbnail hover preview.
  const handleThumbMouseEnter = (item, event) => {
    if (isVideoFile(item) || failedImages.includes(item)) {
      return;
    }

    const rect = event.currentTarget.getBoundingClientRect();

    setHoveredThumb(item);

    setThumbTooltipPos({
      top: rect.top,
      left: rect.right + 15,
    });
  };

  const handleThumbMouseLeave = () => {
    setHoveredThumb(null);
  };

  // WhatsApp enquiry.
  const handleWhatsApp = () => {
    if (!product) return;

    const message = `Hello,

I'm interested in this product.

Product: ${product.name}
Price: ₹${Number(product.price || 0).toLocaleString("en-IN")}

Product Link: ${window.location.href}

Please contact me.`;

    const phoneNumber = "917720089312";

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  // Loading state.
  if (loading) {
    return (
      <div className="container product-status">
        <h2>Loading Product...</h2>
      </div>
    );
  }

  // Error / product not found state.
  if (!product) {
    return (
      <div className="container product-status">
        <h2>{loadError ? "Unable to Load Product" : "Product Not Found"}</h2>

        {loadError && <p>{loadError}</p>}

        <p>
          {loadError
            ? "Please check your connection and try again."
            : "This product may have been removed or is unavailable."}
        </p>
      </div>
    );
  }

  const formattedPrice = Number(product.price || 0).toLocaleString("en-IN");

  const formattedOldPrice = Number(product.oldPrice || 0).toLocaleString(
    "en-IN",
  );

  const currentMediaFailed =
    selectedMedia && failedImages.includes(selectedMedia);

  return (
    <>
      <section className="product-details">
        <div className="container">
          <div className="breadcrumb">
            Home / Collection / {product.displayCategory}
          </div>

          <div className="product-wrapper">
            {/* Product gallery */}
            <div className="product-gallery">
              <div className="thumbnail-wrapper">
                <div className="thumbnail-images">
                  {media.map((item, index) => {
                    const isVideo = isVideoFile(item);
                    const isFailed = failedImages.includes(item);
                    const isActive = selectedMedia === item;

                    return (
                      <button
                        type="button"
                        key={`${item}-${index}`}
                        className={
                          isActive
                            ? `thumb ${isVideo ? "video-thumb" : ""} active`
                            : `thumb ${isVideo ? "video-thumb" : ""}`
                        }
                        onClick={() => handleMediaSelect(item)}
                        onMouseEnter={(event) =>
                          handleThumbMouseEnter(item, event)
                        }
                        onMouseLeave={handleThumbMouseLeave}
                        aria-label={
                          isVideo
                            ? "View product video"
                            : `View product image ${index + 1}`
                        }
                      >
                        {isVideo ? (
                          <span className="video-play-icon">▶</span>
                        ) : isFailed ? (
                          <span className="image-fallback">
                            Image unavailable
                          </span>
                        ) : (
                          <img
                            src={item}
                            alt={`${product.name} thumbnail ${index + 1}`}
                            loading="lazy"
                            onError={() => handleMediaError(item)}
                          />
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Main image / video */}
              <div
                className="main-image"
                ref={imageContainerRef}
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
                onClick={() => {
                  if (
                    selectedMedia &&
                    !isVideoFile(selectedMedia) &&
                    !currentMediaFailed
                  ) {
                    setIsModalOpen(true);
                  }
                }}
                style={{
                  cursor:
                    !isVideoFile(selectedMedia) && !currentMediaFailed
                      ? "zoom-in"
                      : "default",
                }}
              >
                {media.length > 1 && (
                  <>
                    <button
                      type="button"
                      className="slider-arrow left"
                      onClick={(event) => {
                        event.stopPropagation();
                        prevSlide();
                      }}
                      aria-label="Previous image"
                    >
                      <FaChevronLeft />
                    </button>

                    <button
                      type="button"
                      className="slider-arrow right"
                      onClick={(event) => {
                        event.stopPropagation();
                        nextSlide();
                      }}
                      aria-label="Next image"
                    >
                      <FaChevronRight />
                    </button>
                  </>
                )}

                {!selectedMedia ? (
                  <div className="image-fallback main-image-fallback">
                    No product images available
                  </div>
                ) : currentMediaFailed ? (
                  <div className="image-fallback main-image-fallback">
                    <p>Unable to load this media.</p>
                    <button
                      type="button"
                      onClick={(event) => {
                        event.stopPropagation();

                        setFailedImages((previous) =>
                          previous.filter((item) => item !== selectedMedia),
                        );
                      }}
                    >
                      Try Again
                    </button>
                  </div>
                ) : isVideoFile(selectedMedia) ? (
                  <video
                    key={selectedMedia}
                    controls
                    loop
                    playsInline
                    preload="metadata"
                    onError={() => handleMediaError(selectedMedia)}
                  >
                    <source src={selectedMedia} />
                    Your browser does not support HTML5 video.
                  </video>
                ) : (
                  <>
                    <img
                      key={selectedMedia}
                      src={selectedMedia}
                      alt={product.name}
                      onError={() => handleMediaError(selectedMedia)}
                    />

                    {isHovering && (
                      <div className="zoom-lens-overlay" style={zoomStyle} />
                    )}

                    <div className="zoom-hint">
                      <FaSearchPlus /> Click to expand
                    </div>
                  </>
                )}

                {media.length > 0 && (
                  <div className="image-counter">
                    {currentIndex + 1} / {media.length}
                  </div>
                )}
              </div>
            </div>

            {/* Product information */}
            <div className="product-info">
              <span className="product-category">
                {product.displayCategory}
              </span>

              <h1 className="product-title">{product.name}</h1>

              <div className="product-price-row">
                <h2 className="product-price">₹{formattedPrice}</h2>

                {product.oldPrice > product.price && (
                  <span className="product-old-price">
                    ₹{formattedOldPrice}
                  </span>
                )}
              </div>

              <p className="tax-text">Inclusive of all taxes</p>

              {product.soldOut && (
                <p className="sold-out-message">Currently Sold Out</p>
              )}

              <div className="short-description">
                <p>{product.description}</p>
              </div>

              <div className="product-buttons">
                <button
                  type="button"
                  className="cart-btn"
                  disabled={product.soldOut}
                  onClick={() => {
                    // Connect your cart functionality here.
                    console.log("Add to cart:", product.id);
                  }}
                >
                  {product.soldOut ? "SOLD OUT" : "ADD TO CART"}
                </button>

                <button
                  type="button"
                  className="whatsapp-btn"
                  onClick={handleWhatsApp}
                >
                  <FaWhatsapp /> ENQUIRE ON WHATSAPP
                </button>
              </div>

              <div className="product-highlights">
                <div className="highlight-item">
                  <FaTruck className="highlight-icon" />
                  <div>
                    <h4>Free Shipping</h4>
                    <p>Free delivery across India</p>
                  </div>
                </div>

                <div className="highlight-item">
                  <FaShieldAlt className="highlight-icon" />
                  <div>
                    <h4>100% Authentic</h4>
                    <p>Certified Handloom Saree</p>
                  </div>
                </div>

                <div className="highlight-item">
                  <FaUndoAlt className="highlight-icon" />
                  <div>
                    <h4>Easy Exchange</h4>
                    <p>7 Days Exchange Policy</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Full-screen image lightbox */}
      {isModalOpen &&
        selectedMedia &&
        !currentMediaFailed &&
        !isVideoFile(selectedMedia) && (
          <div className="lightbox-modal" onClick={() => setIsModalOpen(false)}>
            <button
              type="button"
              className="modal-close-btn"
              onClick={() => setIsModalOpen(false)}
              aria-label="Close image preview"
            >
              <FaTimes />
            </button>

            {media.length > 1 && (
              <>
                <button
                  type="button"
                  className="slider-arrow left"
                  onClick={(event) => {
                    event.stopPropagation();
                    prevSlide();
                  }}
                  aria-label="Previous image"
                >
                  <FaChevronLeft />
                </button>

                <button
                  type="button"
                  className="slider-arrow right"
                  onClick={(event) => {
                    event.stopPropagation();
                    nextSlide();
                  }}
                  aria-label="Next image"
                >
                  <FaChevronRight />
                </button>
              </>
            )}

            <div
              className="modal-content"
              onClick={(event) => event.stopPropagation()}
            >
              <img
                src={selectedMedia}
                alt={`${product.name} enlarged`}
                className="modal-image"
                onError={() => handleMediaError(selectedMedia)}
              />
            </div>
          </div>
        )}

      {/* Thumbnail hover preview */}
      {hoveredThumb && !failedImages.includes(hoveredThumb) && (
        <div
          className="thumb-hover-preview"
          style={{
            top: `${thumbTooltipPos.top}px`,
            left: `${thumbTooltipPos.left}px`,
          }}
        >
          <img src={hoveredThumb} alt="Product image preview" />
        </div>
      )}

      <ProductAccordion product={product} />
    </>
  );
};

export default ProductDetails;
